import { composeInitialState } from '@opengov/compose-app';
import { composeStateMachine } from '@opengov/compose-app/core/module';

import { ControlBlockStatus } from '../types';

export type ILayoutBlockState = {
  isDrawerOpen: boolean;
  expandedControlBlockIndex: number;
  displayGlobalFilters: boolean;
  displayColumnFilters: boolean;
  expandedColumnBlockIndex?: number;
};

export type IControlBlockState = {
  blockIndex: number;
  placeholder: string;
  description: string;
};

export type IDimensionalTable = {
  layoutBlockState: ILayoutBlockState;
  controlBlockModalState: IControlBlockState;
};

export const initialState = {
  layoutBlockState: {
    isDrawerOpen: true,
    expandedControlBlockIndex: null,
    displayGlobalFilters: false,
    displayColumnFilters: false,
    expandedColumnBlockIndex: null
  },
  controlBlockModalState: {
    blockIndex: 0,
    placeholder: '',
    description: '',
    controlBlockStatus: ControlBlockStatus.Current
  }
};

export const dimensionalTableInitialState = composeInitialState(initialState);

export const dimensionalTableState = composeStateMachine(
  'dimension-summary-table',
  dimensionalTableInitialState,
  (compose) => ({
    changeDrawerVisibility: compose.action((state, payload) =>
      state.setIn(['layoutBlockState', 'isDrawerOpen'], payload)
    ),
    updateControlBlockIndex: compose.action((state, payload) => {
      const existingIndex = state.getIn(['layoutBlockState', 'expandedControlBlockIndex']);
      return state.setIn(['layoutBlockState', 'expandedControlBlockIndex'], existingIndex === payload ? null : payload);
    }),
    changeGlobalFilterVisibility: compose.action((state, payload) => {
      return state.setIn(['layoutBlockState', 'displayGlobalFilters'], payload);
    }),
    changeColumnFilterVisibility: compose.action((state, payload) => {
      return state.setIn(['layoutBlockState', 'displayColumnFilters'], payload);
    }),
    updateExpandedColumnBlockIndex: compose.action((state, payload) => {
      return state.setIn(['layoutBlockState', 'expandedColumnBlockIndex'], payload);
    }),
    resetdimensionalTableState: compose.payloadlessAction((_state) => dimensionalTableInitialState),
    updateControlBlockModalState: compose.action((state, payload) => {
      return state.set('controlBlockModalState', { ...state.get('controlBlockModalState', {}), ...payload });
    }),
    updateControlBlockStatus: compose.action((state, payload) => {
      return state.setIn(['controlBlockModalState', 'controlBlockStatus'], payload);
    })
  })
);

export const {
  actions: dimensionalTableActions,
  actionCreators: dimensionalTableActionCreators,
  reducer: dimensionalTableReducer,
  selector: dimensionalTableSelector
} = dimensionalTableState;
